import {
    PlacementInstruction,
    PlacementInstructionConfigs,
} from '../../shared/types/reklameMaster';
import { MessageBus } from '@podium/browser';
import { events } from '@schibsted-nmp/advertising-events';
import { getConfig } from '../config';

export function getType(index: number) {
    const config = getConfig();
    const hasContentMarketing = config?.contentMarketing?.length > 0;
    if (hasContentMarketing && index === 1) {
        return 'content-marketing';
    }

    return 'ast';
}

// Type guard to check if the input is of type PlacementInstructionConfigs
function isPlacementInstructionConfigs(
    placeInstruction: PlacementInstruction[] | PlacementInstructionConfigs,
): placeInstruction is PlacementInstructionConfigs {
    return Array.isArray(placeInstruction) && 'data' in placeInstruction[0];
}

function getNewOrOldPlacementInstructions(
    placementInstructions: PlacementInstruction[] | PlacementInstructionConfigs,
): PlacementInstructionConfigs {
    if (isPlacementInstructionConfigs(placementInstructions)) {
        return placementInstructions;
    } else {
        return [
            {
                type: 'search',
                data: placementInstructions,
            },
        ];
    }
}
export function companionReadyPlacementListener(
    placementInstruction: PlacementInstruction[],
) {
    const messageBus = new MessageBus();

    messageBus.publish(
        events.COMPANION.channel,
        events.COMPANION.PODLET_READY.topic,
        {
            placementInstructionConfigs:
                getNewOrOldPlacementInstructions(placementInstruction),
        },
    );
}
